<template>
  <div class="top">
    <div class="container">
      <div class="row d-flex justify-content-center">
        <div>
          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />
        </div>
        <div class="col-lg-12 rowSpace"></div>
        <div class="text-center col-lg-12 mainTitle">핀크스 레저</div>
        <div class="mainTitleLine">
          <hr />
        </div>
        <div class="col-lg-12 text-center mainIntro">
          <span>High-end 고객을 위한 프리미엄 레저 프로그램</span>
          <p>포도호텔 제휴사에서 다양한 할인 혜택을 받으실 수 있습니다.</p>
        </div>
        <div class="rowSpace"></div>
        <div class="embed-responsive embed-responsive-16by9 mb-5">
          <iframe
            class="embed-responsive-item"
            src="https://player.vimeo.com/video/570206717?byline=0&portrait=0&title=0&background=0&autoplay=1&loop=1"
            allowfullscreen
          >
          </iframe>
        </div>
      </div>

      <div class="row d-flex">
        <div class="col-lg-4 col-12 mb-4">
          <div class="card itemContainer">
            <router-link to="/p/Luxuryyacht">
              <img
                class="card-img-top"
                src="@/assets/images/pleisure/pleisure_bodyimage01.jpg"
                alt="Card image cap"
                style="padding: 10px"
            /></router-link>
            <div class="card-body">
              <h5 class="card-title">프라이빗 럭셔리요트</h5>
              <div class="lineStyle"><hr /></div>
              <p class="card-text">제주 최고의 요트에서 즐기는 스페셜 럭셔리 제주 여행</p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-12 mb-4">
          <div class="card itemContainer">
            <router-link to="/p/Challengergolf">
              <img
                class="card-img-top"
                src="@/assets/images/pleisure/pleisure_bodyimage02.jpg"
                alt="Card image cap"
                style="padding: 10px"
            /></router-link>
            <div class="card-body">
              <h5 class="card-title">챌린저 골프</h5>
              <div class="lineStyle"><hr /></div>
              <p class="card-text">한국 최초의 세계 100대 골프장에서 경험하는 프리미엄 골프 레슨</p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-12 mb-4">
          <div class="card itemContainer">
            <router-link to="/p/Nobleriding">
              <img
                class="card-img-top"
                src="@/assets/images/pleisure/pleisure_bodyimage03.jpg"
                alt="Card image cap"
                style="padding: 10px"
            /></router-link>
            <div class="card-body">
              <h5 class="card-title">노블승마</h5>
              <div class="lineStyle"><hr /></div>
              <p class="card-text">전문 교관의 정통 승마 강습부터 외승 체험까지</p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-12 mb-4">
          <div class="card itemContainer">
            <router-link to="/p/Jejufisherman">
              <img
                class="card-img-top"
                src="@/assets/images/pleisure/pleisure_bodyimage04.jpg"
                alt="Card image cap"
                style="padding: 10px"
            /></router-link>
            <div class="card-body">
              <h5 class="card-title">제주어부</h5>
              <div class="lineStyle"><hr /></div>
              <p class="card-text">제주 바다를 고스란히 느끼는 익스트림 액티비티</p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-12 mb-4">
          <div class="card itemContainer">
            <router-link to="/p/Happytogether">
              <img
                class="card-img-top"
                src="@/assets/images/pleisure/pleisure_bodyimage05.jpg"
                alt="Card image cap"
                style="padding: 10px"
            /></router-link>
            <div class="card-body">
              <h5 class="card-title">해피투게더</h5>
              <div class="lineStyle"><hr /></div>
              <p class="card-text">제주의 숲, 식물 이야기</p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-12 mb-4">
          <div class="card itemContainer">
            <router-link to="/p/Forestorytellingtour">
              <img
                class="card-img-top"
                src="@/assets/images/pleisure/pleisure_bodyimage06.jpg"
                alt="Card image cap"
                style="padding: 10px"
            /></router-link>
            <div class="card-body">
              <h5 class="card-title">제주 숲토리텔링 투어</h5>
              <div class="lineStyle"><hr /></div>
              <p class="card-text">숲토리텔러와 함께하는 프라이빗 숲 트레킹</p>
            </div>
          </div>
        </div>

        <table class="table table-border subTable">
          <tbody>
            <tr>
              <td>운영시간</td>
              <td>월~금(공휴일 제외) 09:00 ~ 17:30 (점심시간 12:00 ~ 13:00)</td>
            </tr>
            <tr>
              <td>문의</td>
              <td>064)793-7070, 010-5328-7050, <ObfuscatedEmail email-key="leisure" /></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pleisure',
};
</script>

<style scoped lang="scss">
td {
  vertical-align: middle;
}
.top {
  padding-top: 11rem;
}
.mainTitle {
  font-weight: 800;
  font-size: 2rem;
  letter-spacing: -0.1rem;
}
.mainTitleLine {
  width: 10%;
  > hr {
  }
}
.mainIntro {
  > span {
    font-size: 1.2rem;
    font-weight: 600;
    margin: 0px;
  }
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff;
  }
  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
.subContainer {
  width: 100%;
}
.mainInfo {
  padding: 1rem;
  width: 100%;
  height: 100%;
  > div {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
.serviceArea {
  padding: 1rem;
  > span {
    font-size: 0.8rem;
  }
}
.subTitle {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.subDetail {
  font-size: 0.9rem;
  padding-left: 1rem;
}
.subTable {
  > thead {
    background-color: #eaeaea;

    > tr > td {
      font-weight: 600;
    }
  }
  > tbody {
    > tr > td {
      font-size: 0.9rem;
    }
  }
}
.card-body {
  height: 10rem;
  > p {
    font-size: 0.9rem;
    word-break: keep-all;
    letter-spacing: -0.03rem;
  }
}
.rowSpace {
  width: 100%;
  height: 2rem;
  > hr {
  }
}
.card-title {
  font-weight: 600;
  letter-spacing: -0.05rem;
}
</style>
